/** Static loading placeholder line (no shimmer). */
export function Skeleton() {
  return <span className="skeleton" aria-hidden="true" />
}
